import React from "react";
import { NavLink } from "react-router-dom";
import {
  Home,
  Car,
  Truck,
  Handshake,
  MessageCircle,
} from "lucide-react";

const items = [
  {
    to: "/",
    label: "Home",
    icon: Home,
  },
  {
    to: "/tours",
    label: "Tours",
    icon: Car,
  },
  {
    to: "/vehicles",
    label: "Motors",
    icon: Truck,
  },
  {
    to: "/consultancy",
    label: "Consult",
    icon: Handshake,
  },
  {
    to: "/contact",
    label: "Contact",
    icon: MessageCircle,
  },
];

const BottomNavigation = () => {
  return (
    <nav
      className="
        fixed bottom-0 left-0 right-0 z-50
        px-3 pb-2
        md:hidden
        pointer-events-none
      "
      style={{
        paddingBottom: "max(8px, env(safe-area-inset-bottom))",
      }}
      aria-label="Mobile navigation"
    >
      <div
        className="
          pointer-events-auto
          mx-auto max-w-md
          rounded-2xl
          border border-white/70
          bg-white/90
          shadow-[0_-4px_30px_rgba(6,26,58,0.10)]
          backdrop-blur-xl
          supports-[backdrop-filter]:bg-white/75
        "
      >
        <div className="grid grid-cols-5 px-1.5 py-1.5">
          {items.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              className="relative flex min-h-[58px] items-center justify-center"
            >
              {({ isActive }) => (
                <div
                  className={`
                    relative flex h-[52px] min-w-[58px]
                    flex-col items-center justify-center
                    gap-1 rounded-xl px-2
                    transition-all duration-300 ease-out
                    ${
                      isActive
                        ? "bg-[#00A260]/10 text-[#00A260]"
                        : "text-[#64748B] hover:bg-[#F1F5F3]"
                    }
                  `}
                >
                  {/* Active indicator */}
                  {isActive && (
                    <span
                      className="
                        absolute -top-1
                        h-1 w-7
                        rounded-full
                        bg-[#00A260]
                        shadow-[0_2px_8px_rgba(0,162,96,0.35)]
                        animate-[navIndicator_300ms_ease-out]
                      "
                    />
                  )}

                  {/* Icon */}
                  <span
                    className={`
                      flex h-6 w-6 items-center justify-center
                      transition-all duration-300
                      ${
                        isActive
                          ? "scale-110"
                          : "scale-100"
                      }
                    `}
                  >
                    <Icon
                      strokeWidth={isActive ? 2.5 : 2}
                      className="h-[21px] w-[21px]"
                    />
                  </span>

                  {/* Label */}
                  <span
                    className={`
                      text-[10px]
                      leading-none
                      transition-all duration-300
                      ${
                        isActive
                          ? "font-bold text-[#005543]"
                          : "font-medium text-[#64748B]"
                      }
                    `}
                  >
                    {label}
                  </span>
                </div>
              )}
            </NavLink>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes navIndicator {
          from {
            opacity: 0;
            transform: scaleX(0);
          }
          to {
            opacity: 1;
            transform: scaleX(1);
          }
        }
      `}</style>
    </nav>
  );
};

export default BottomNavigation;